export default __webpack_public_path__ + "static/media/DSC_0584.17c68806.jpg";